import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";

const AboutPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b bg-white sticky top-0 z-50 shadow-sm">
        <div className="mx-auto max-w-6xl px-3 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl sm:text-2xl font-bold text-neutral-800">
              Sobre el Yogur y Nosotros
            </h1>
            <Button
              variant="pastel"
              onClick={onBack}
              aria-label="Volver a la tienda"
              className="flex items-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Volver</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-3 py-6">
        <Card>
          <CardContent className="space-y-4 pt-6">
            <div className="prose prose-neutral max-w-none">
              <h3 className="text-lg font-semibold mb-3">Nuestro Yogur</h3>
              <p className="text-neutral-600 mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor 
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
              </p>
              
              <h3 className="text-lg font-semibold mb-3">Cómo lo Hacemos</h3>
              <p className="text-neutral-600 mb-4">
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
                fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
                culpa qui officia deserunt mollit anim id est laborum.
              </p>
              
              <h3 className="text-lg font-semibold mb-3">Nuestra Historia</h3>
              <p className="text-neutral-600 mb-4">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque 
                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi 
                architecto beatae vitae dicta sunt explicabo.
              </p>
              
              <h3 className="text-lg font-semibold mb-3">Nuestros Valores</h3>
              <p className="text-neutral-600">
                Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia 
                consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro 
              quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.
            </p>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

AboutPage.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default AboutPage;
